import React, { Component } from "react";

export default class CollectionTableData extends Component {
    constructor(props) {
        super(props);
    }

    getHeader = () => {
        return (<tr>
            <th>
                <div>
                    Pat Num
                </div>
            </th>
            <th><div>Category</div></th>
            <th><div>Practice</div></th>
            <th><div>Dr Name</div></th>
            <th><div>OD User</div></th>
            <th><div>Proc Date</div></th>
            <th><div>Entry/Deposit Date</div></th>
            <th><div>Amount</div></th>
        </tr>)


    }



    getColumns2 = () => {
        let returnArray = [];
        const collectionList = this.props.CollectionList;
        const { getPracticeName } = this.props
        if (collectionList.length > 0) {
            let totalAmount = 0;
            collectionList.forEach((collection, i) => {
                totalAmount += collection.Amount;
                collection.PracticeName = getPracticeName(collection.Practice)
                returnArray.push(
                    <tr key={`${i}-2`}>
                        <td className="primaryColor cursorPointer"><span onClick={() => this.props.openFamilyView(collection.PatNum, collection.Practice, collection.PracticeName)}>{collection.PatNum}</span></td>
                        <td>{collection.Category}</td>
                        <td>{collection.PracticeName}</td>
                        <td>{collection.DrName}</td>
                        <td>{collection.OD_user}</td>
                        <td>{collection.ProcDate}</td>
                        <td>{collection.EntryDate}</td>
                        <td>$ {collection.Amount.toFixed(2)}</td>
                    </tr>
                );
            })
            returnArray.push(
                <tr key={'total'}>
                    <td colSpan="7"><strong>Total</strong></td>
                    <td><strong>$ {totalAmount.toFixed(2)}</strong></td>
                </tr>
            );
            ;
        } else {
            returnArray.push(
                <tbody>
                    <tr>
                        <td colSpan="7">No Record Found</td>
                    </tr>
                </tbody>
            )
        }
        return returnArray;
    }

    render() {
        let columns;
       
            columns = [];
            columns.splice(0, columns.length);
            columns = this.getColumns2();
       
        return (
            <table className="table table-striped fixed compact table-hover my-0 TableHeaderFixed">
                <thead>
                    {this.getHeader()}
                </thead>
                <tbody>
                    {columns}
                </tbody>
            </table>
        );
    }
}